module.exports = __webpack_public_path__ + "static/9000-border-6d4fcb530051488e8c9b5789c84a4eb7.jpg";